function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useRef, useEffect, useMemo, useState } from 'react';
import NotificationSnackbarContext from './NotificationSnackbarContext';
import { WmSnackbar } from '@watermarkinsights/ripple-react';
import uuid from '../utils/uuid';

// Store callback in ref so that entire component tree doesn't re-render every
// time notifications change
function useNotificationCallback(handler, deps) {
  var ref = useRef();
  ref.current = useCallback(handler, deps);
  return useCallback(function () {
    ref.current.apply(ref.current, arguments);
  }, [ref]);
}
export default function NotificationSnackbar(_ref) {
  var children = _ref.children;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  var snackbarId = useMemo(function () {
    return uuid();
  }, []);
  var handleAction = useCallback(function (event) {
    var id = event.detail.id;
    var notification = notifications.find(function (n) {
      return n.id === id;
    });
    if (notification && notification.onClick) {
      notification.onClick(notification);
    }
  }, [notifications]);
  var handleDismiss = useCallback(function (event) {
    var id = event.detail.id;
    setNotifications(notifications.filter(function (n) {
      return n.id !== id;
    }));
  }, [notifications]);
  useEffect(function () {
    var snackbar = document.getElementById(snackbarId);
    snackbar.addEventListener('wmSnackbarActionTriggered', handleAction);
    snackbar.addEventListener('wmSnackbarSnackFinished', handleDismiss);
    snackbar.notifications = JSON.stringify(notifications.map(function (n) {
      return {
        id: n.id,
        link: n.link,
        message: n.message,
        newWindow: n.newWindow
      };
    }));
    return function () {
      snackbar.removeEventListener('wmSnackbarActionTriggered', handleAction);
      snackbar.removeEventListener('wmSnackbarSnackFinished', handleDismiss);
    };
  }, [snackbarId, notifications, handleDismiss, handleAction]);
  var notify = useNotificationCallback(function (_ref2) {
    var message = _ref2.message,
      link = _ref2.link,
      newWindow = _ref2.newWindow,
      onClick = _ref2.onClick,
      options = _ref2.options;
    var id = uuid();
    setNotifications([{
      id: id,
      message: message,
      link: !!link ? link : '',
      newWindow: !!newWindow,
      onClick: onClick,
      options: options
    }].concat(_toConsumableArray(notifications)));
  }, [notifications]);
  var context = useMemo(function () {
    return {
      notify: notify
    };
  }, [notify]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NotificationSnackbarContext.Provider, {
    value: context
  }, children), /*#__PURE__*/React.createElement(WmSnackbar, {
    id: snackbarId
  }), /*#__PURE__*/React.createElement("div", {
    className: "auto-notification-snackbar sr-only",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("ol", null, notifications.map(function (notification) {
    return /*#__PURE__*/React.createElement("li", null, notification.message);
  }))));
}